<app-navigation></app-navigation>
<div class="top-navi-container">
  <button class="top-navi" (click)="onNavigateBack()" mat-button><mat-icon>arrow_back</mat-icon>Zurück</button>
</div>
<mat-card class="card">
  <mat-card-content>
    <div class="h2 title">Papier-Assessments</div>

    <table mat-table [dataSource]="customEditingAssessmentList()" class="mat-elevation-z8 fixed-width no-width-change">
      <!-- Sichtbarkeit -->
      <ng-container matColumnDef="visibility">
        <th mat-header-cell *matHeaderCellDef>Sichtbarkeit</th>
        <td mat-cell *matCellDef="let assessment">
          @if (!assessment.editing) {
            <mat-icon
              (click)="toggleVisibility(assessment)"
              style="cursor: pointer"
              [attr.aria-label]="assessment.visible ? 'Sichtbar' : 'Nicht sichtbar'">
              {{ assessment.visible ? 'visibility' : 'visibility_off' }}
            </mat-icon>
          }
        </td>
      </ng-container>

      <!-- Name oder Bearbeitungsfelder -->
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef>Name</th>
        <td mat-cell *matCellDef="let assessment">
          <ng-container *ngIf="!assessment.editing">
            <h3>{{ assessment.shortName }}</h3>
          </ng-container>
          <ng-container *ngIf="!assessment.editing">
            {{ assessment.fullName }}
          </ng-container>
          <ng-container *ngIf="assessment.editing">
            <div class="edit-mode">
              <mat-form-field appearance="fill">
                <mat-label>Kürzel</mat-label>
                <input matInput [(ngModel)]="assessment.shortName" />
                <mat-hint>Z. B. "ARAT" oder "NHPT"</mat-hint>
              </mat-form-field>

              <mat-form-field appearance="fill">
                <mat-label>Voller Name (optional)</mat-label>
                <input matInput [(ngModel)]="assessment.fullName" />
                <mat-hint>Z. B. "Action Research Arm Test" oder "Nine Hole Peg Test"</mat-hint>
              </mat-form-field>

              <mat-radio-group [(ngModel)]="assessment.sideDistinction" [disabled]="assessment._documentId">
                <mat-radio-button [value]="true">Unterscheidet links und rechts</mat-radio-button>
                <mat-radio-button [value]="false">Keine Seitenunterscheidung</mat-radio-button>
              </mat-radio-group>
            </div>
          </ng-container>
        </td>
      </ng-container>

      <!-- Aktion Spalte -->
      <ng-container matColumnDef="action">
        <th mat-header-cell *matHeaderCellDef class="action">Aktion</th>
        <td mat-cell *matCellDef="let assessment">
          <button *ngIf="!assessment.editing" mat-button (click)="editAssessment(assessment)">Bearbeiten</button>
          <button *ngIf="assessment.editing" mat-button (click)="cancel(assessment)">Abbrechen</button>
          <button *ngIf="assessment.editing" mat-button (click)="saveAssessment(assessment)">Speichern</button>
          <!-- <button *ngIf="assessment.editing" mat-button (click)="deleteAssessment(assessment)">Löschen</button> -->
        </td>
      </ng-container>

      <!-- Header Row -->
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <!-- Data Rows -->
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>

    <!-- Button zum Hinzufügen eines neuen Assessments -->
    <div class="add-button-container">
      <button mat-button (click)="addNewAssessment()"><mat-icon>edit</mat-icon> Neues Papier-Assessment anlegen</button>
    </div>
  </mat-card-content>
</mat-card>
